<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'
import SkrButtonGroup from '@/components/button/SkrButtonGroup.vue'
import OverlayBase from '@/components/overlays/OverlayBase.vue'
import ResponsiveImage from '@/components/ResponsiveImage.vue'
import SkrHeading from '@/components/SkrHeading.vue'

const emit = defineEmits<{
  (e: 'close'): void
}>()

const { t } = useI18n()
</script>

<template>
  <overlay-base>
    <v-container class="overlay__body fill-height">
      <v-row align="center">
        <v-col cols="12" md="5" order="2" order-md="1">
          <skr-heading class="overlay__title" level="1" semantic>{{
            t('sign.error.serialnomismatch.title')
          }}</skr-heading>
          <div class="mb-6">
            <p class="whitespace-pre-line">{{ t('sign.error.serialnomismatch.text') }}</p>
          </div>
          <skr-button-group size="lg" stacked>
            <skr-button data-cy="check_status_button" :href="t('sign.error.serialnomismatch.cta_url')">{{
              t('sign.error.serialnomismatch.cta')
            }}</skr-button>
            <skr-button type="text" @click="emit('close')">
              {{ t('sign.error.serialnomismatch.back') }}
            </skr-button>
          </skr-button-group>
          <div class="pt-12">
            <p>
              <i18n-t keypath="sign.error.help.text">
                <template #question>
                  <strong>{{ t('sign.error.help.question') }}</strong>
                </template>
                <template #contactText>
                  <a :href="t('sign.error.help.link_url')" target="_blank" rel="noopener">{{
                    t('sign.error.help.link_text')
                  }}</a>
                </template>
              </i18n-t>
            </p>
          </div>
        </v-col>
        <v-col cols="12" md="7" order="1" order-md="2">
          <responsive-image source="tan-expired" :width="560" :height="511" />
        </v-col>
      </v-row>
    </v-container>
  </overlay-base>
</template>

<style lang="scss" scoped>
.overlay__title {
  font-size: 2rem;
  margin-bottom: 1rem;
}
</style>
